import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { iconTrashBlue } from '../../../../assets';
import { DevLabelEnum } from '../../../../configs/language/developersTranslations';
import { convertDateToHumanReadable } from '../../../../utils/formater';
import { selectSelectedLanguage } from '../../../store/language/selectors';
import { ICredentialResponse } from '../../Credentials.interface';
import CredentialsTableStyles from './CredentialsTable.styles';

interface CredentialsTableProps {
  credentials: ICredentialResponse[];
  handleDelete: (credential: ICredentialResponse) => void;
}

const CredentialsTable = ({
  credentials,
  handleDelete,
}: CredentialsTableProps) => {
  const { language } = useSelector(selectSelectedLanguage);
  const { t } = useTranslation();

  return (
    <div className={CredentialsTableStyles.contentTable}>
      <table>
        <thead>
          <tr>
            <th>{t(DevLabelEnum.DEV_ALIAS)}</th>
            <th>{t(DevLabelEnum.DEV_KEY_ID)}</th>
            <th>{t(DevLabelEnum.DEV_KEY_CREATED)}</th>
            <th>{t(DevLabelEnum.DEV_KEY_ACTION)}</th>
          </tr>
        </thead>
        <tbody>
          {credentials.map((element: ICredentialResponse) => (
            <tr key={element.id}>
              <td>{element.alias}</td>
              <td>{element.clientId}</td>
              <td>
                {convertDateToHumanReadable(
                  element.createdAt,
                  language,
                  DateTime.DATE_MED
                )}
              </td>
              <td className={CredentialsTableStyles.actions}>
                <Button
                  className={CredentialsTableStyles.iconActions}
                  onClick={() => handleDelete(element)}
                >
                  <img src={iconTrashBlue} alt="button" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CredentialsTable;
